import React, { Suspense, useMemo } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { STLLoader } from "three-stdlib";
import { useLocation, useNavigate } from "react-router-dom";
import * as THREE from "three";

const STLModel = ({ url }: { url: string }) => {
  const geometry = useLoader(STLLoader, url);
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  const geo = useMemo(() => {
    const bufferGeo = geometry;

    if (!(bufferGeo instanceof THREE.BufferGeometry)) {
      return new THREE.BufferGeometry();
    }

    const cloned = bufferGeo.clone();

    cloned.computeBoundingBox();
    cloned.center();
    cloned.computeVertexNormals();

    return cloned;
  }, [geometry]);

  return (
    <mesh>
      <primitive object={geo} attach="geometry" />
      <meshStandardMaterial
        color="#fff"
        metalness={0.3}
        roughness={0.6}
      />
    </mesh>
  );
};

/* ================= PAGE ================= */
const AdminstlpreviewNew = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const stlUrl = location.state?.stlUrl;


  return (
    <>
      <style>
        {`
          .modal-backdrop {
            background-color: transparent !important;
            pointer-events: none !important;
          }
        `}
      </style>
      <div
        className="pb-2 d-flex align-items-center gap-2 back-btn"
        onClick={() => navigate(-1)}
      >
        <i className="bi bi-arrow-left" style={{ fontSize: "20px" }}></i>
        <span className="back-text">Back</span>
      </div>
      <div className="shadow-container rounded p-3" style={{
        height: "100vh",
      }}>



        <Canvas
          camera={{ position: [0, 0, 150], fov: 45 }}
          onCreated={({ gl }) => gl.setClearColor("#090000", 1)}
        >
          <ambientLight intensity={0.7} />
          <directionalLight position={[20, 20, 20]} intensity={1.2} />

          <Suspense fallback={null}>
            <STLModel url={stlUrl} />
          </Suspense>

          <OrbitControls />
        </Canvas>
      </div>
    </>
  );
};

export default AdminstlpreviewNew;
